export default __webpack_public_path__ + "images/Icon material-add-a-photo.65670added5c3c167185ccf620bb28ec.svg";